import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { openDialog, closeDialog } from 'app/store/fuse/dialogSlice';
/* eslint-disable-next-line import/no-cycle */
import ViewPageContentWrapper from '../../page-layouts/view/ViewPageContentWrapper';

import useSettings from '../../hooks/useSettings';
/* eslint-disable-next-line import/no-cycle */
import usePagination from '../../hooks/usePagination';
import useSelection from '../../hooks/useSelection';

import { type ModuleSearchFieldProps } from '../ModuleSearchField';

/* eslint-disable-next-line import/no-cycle */
import ListItemsManager from 'app/main/modules/components/ListItemManager';
/* eslint-disable-next-line import/no-cycle */
import TablesColumnsManager from 'app/main/modules/components/TablesColumnsManager';

type ModuleSearchFieldDialogProps = Pick<ModuleSearchFieldProps, 'label' | 'module' | 'filters' | 'value'> & {
	sendChange: (newValue: any) => void;
	parseOptionLabel: (option: any) => string;
};

export const showModuleSearchFieldDialog = (props: ModuleSearchFieldDialogProps) =>
	openDialog({
		children: <ModuleSearchFieldDialog {...props} />,
		maxWidth: 'lg',
		fullWidth: true
	});

export default function ModuleSearchFieldDialog(props: ModuleSearchFieldDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(props.module);

	const paginationProps = usePagination({
		module: settings.modu_title,
		filter: { defaultFilters: props.filters }
	});

	const { selectedItems, setSelectedItems } = useSelection({
		mode: 'single',
		module: props.module,
		isSelecting: true,
		defaultSelectedItems: props.value ? [props.value] : undefined
	});

	const [refresh, setRefresh] = React.useState(true);
	const updateRefresh = () => setRefresh(state => !state);

	const handleCloseDialog = () => {
		setSelectedItems(props.value ? [props.value] : []);
		dispatch(closeDialog());
	};

	const handleConfirmDialog = () => {
		props.sendChange(selectedItems[0]);
		dispatch(closeDialog());
	};

	// On first render the props.value is undefined and defaultSelectedItems is empty
	// React.useEffect(() => setSelectedItems(props.value ? [props.value] : []), [props.value, setSelectedItems]);

	const listItem = ListItemsManager[settings.modu_title];
	const getColumns = TablesColumnsManager[settings.modu_title];

	return (
		<>
			<DialogTitle>{props.label}</DialogTitle>
			<DialogContent className="flex flex-col p-0">
				<ViewPageContentWrapper
					className="border-none"
					module={settings.modu_title}
					content={getColumns ? { type: 'table', getColumns } : { type: 'list', itemLayout: listItem }}
					paginationProps={paginationProps}
					refresh={refresh}
					updateRefresh={updateRefresh}
					selectionProps={{ mode: 'single', selectedItems }}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCloseDialog}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button color="secondary" onClick={handleConfirmDialog}>
					{t('DIALOG_ACTION_CONFIRM')}
				</Button>
			</DialogActions>
		</>
	);
}
